export const MANUAL_RECONCILE_MODAL_OPENED_VIA = {
    ORDER: 'ORDER',
    DEPOSIT: 'DEPOSIT',
}

export const RECON_STATUS = {
    RECONCILED: 'RECONCILED',
    NOT_RECONCILED: 'NOT_RECONCILED'
}